module.exports = __webpack_public_path__ + "img/dua-hp.dd7c2196.png";